"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plog = exports.warn = void 0;
exports.warn = console.warn.bind(console);
var plog = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (console.groupCollapsed && console.groupEnd) {
        console.groupCollapsed("Stubbed network (log-client)");
        console.log.apply(console, args);
        console.groupEnd();
    }
    else {
        console.log.apply(console, args);
    }
};
exports.plog = plog;
//# sourceMappingURL=logging.js.map